import CommonFilterNew from "components/CommonFilter/CommonFilterNew";
import AddSingleMemberDropdown from "components/CustomDropdown/AddSingleMemberDropdown";
import ReactDateRangePicker from "components/ReactDateRangePicker/ReactDateRangePicker";
import ClearFilterButton from "components/Search/clearFilterButton";
import BackendExportModal from "custom_modules/ReportsNew/BackendExportModal";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import LeftArrow_3 from "../../assets/img/icons/LeftArrow_3.svg";
import RightArrow_3 from "../../assets/img/icons/RightArrow_3.svg";
import ExportIcon from "../../assets/img/icons/export_icon.svg";
import CreateProjectDropdown from "../../components/DropdownStyle/CreateProjectDropdown";
import BottomPagination from "../../components/Pagination/BottomPagination/BottomPagination";
import TopPagination from "../../components/Pagination/TopPagination/TopPagination";
import Select from "../../components/ReactSelectDropdown";
import { useScrollShadow } from "../../customHooks/useScrollShadow";
import {
  ExportButtonIcon,
  ExportButtonWithIcon,
  WhiteButton,
} from "../../styledComponents/buttons";
import {
  CommonFlex,
  CommonFlexWrap,
  Container,
  ContainerNew,
  FilterLabel,
  HeaderContainer,
  IconArrow,
  InputWithLabelSection,
  PageTitle,
} from "../../styledComponents/common";
import { StickyFilterContainer } from "../../styledComponents/timesheet";
import HelperIcon from "../../components/HelperIcon/HelperIcon";
import ClockInOutTable from "./ClockInOutTable";

const ClockInOut = ({
  history,
  isLoading,
  getClockInOutList,
  clockInOutList,

  getOfficesShortList,
  officesShortList,

  // pagination
  clockInOutListCount,
  clockInOutPageSize,

  selectedOrganization,
  exportClockInOutList,
  getAllMemberLastClockInOut,
  onlineMembers,
  getOfficeDetails,
  officeDetails,

  // member short list (paginated members)
  memberShortListIsLoading,
  orgMembersShortList,
  getOrganizationMembersShortList,
}) => {
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  const showShadow = useScrollShadow(60);
  const [startDate, setStartDate] = useState(
    moment().startOf("week").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("week").format("YYYY-MM-DD"),
  );

  const [selectedOffice, setSelectedOffice] = useState({
    value: null,
    label: "(All Teams)",
  });
  const [officeOptions, setOfficeOptions] = useState([]);

  const [selectedMember, setSelectedMember] = useState(null);
  const [memberOptions, setMemberOptions] = useState([]);
  const [currentSearchedTerm, setCurrentSearchedTerm] = useState("");
  const [attendanceList, setAttendanceList] = useState([]);
  const [attendanceFilter, setAttendanceFilter] = useState({
    value: null,
    label: "(All Attendance)",
  });

  const attendanceFilterOptions = [
    { value: null, label: "(All Attendance)" },
    { value: "clocked_in", label: "Clocked In" },
    { value: "not_clocked_in", label: "Not Clocked In" },
  ];

  const officeFilterOptions = [
    { value: null, label: "(All Teams)" },
    { value: "office_users", label: "(Office Users)" },
    { value: "remote_users", label: "(Remote Users)" },
    ...officeOptions,
  ];

  const { t } = useTranslation();
  const [dateLabel, setDateLabel] = useState("");
  const [dateChanged, setDateChanged] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [timeFormat, setTimeFormat] = useState("1h5m");
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  // count selected filters
  const CommonFilterSelectedCount =
    (attendanceFilter?.value ? 1 : 0) + (selectedOffice?.value ? 1 : 0);

  // updates the attendance filter and resets page to 1

  const updateAttendanceFilter = attendanceFilter => {
    setAttendanceFilter(attendanceFilter);
    setCurrentPageNumber(1);
  };

  // sets selected member and resets page
  const onMemberSelect = person => {
    setCurrentPageNumber(1);
    setSelectedMember(person);
  };

  // clears selected member
  const clearSelectedMember = () => {
    setSelectedMember(null);
  };

  // shifts the date range by one day (left/right navigation arrows)
  const singleDateChange = direction => {
    if (direction === "right") {
      setStartDate(moment(endDate).add(1, "days"));
      setEndDate(moment(endDate).add(1, "days"));
    } else {
      setStartDate(moment(startDate).subtract(1, "days"));
      setEndDate(moment(startDate).subtract(1, "days"));
    }
    setDateChanged(!dateChanged);
  };

  // selects today's date
  const selectToday = () => {
    setStartDate(moment().format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    setDateChanged(!dateChanged);
  };

  // selects last 7 days (including today)
  const selectLastWeek = () => {
    setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    setDateChanged(!dateChanged);
  };

  // selects last 30 days (including today)
  const selectLastMonth = () => {
    setStartDate(moment().subtract(29, "days").format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    setDateChanged(!dateChanged);
  };

  // selects next week (future 7 days)
  const selectNextWeek = () => {
    setStartDate(moment().add(1, "days").format("YYYY-MM-DD"));
    setEndDate(moment().add(7, "days").format("YYYY-MM-DD"));
    setDateChanged(!dateChanged);
  };

  // toggles the export modal
  const toggle = () => {
    setIsExportModalOpen(!isExportModalOpen);
  };

  // updates date range when user picks from calendar
  const changeDateRange = dates => {
    setStartDate(dates.startDate);
    setEndDate(dates.endDate);
  };

  // generates label like "7 days selected" or "Today selected"
  const getDateLabel = () => {
    const diff = Math.ceil(
      moment(endDate).diff(moment(startDate), "days", true),
    );
    if (
      diff === 0 &&
      moment().format("YYYY-MM-DD") === moment(startDate).format("YYYY-MM-DD")
    ) {
      return "Today selected";
    }
    return diff + 1 + " day" + (diff > 0 ? "s" : "") + " " + "selected";
  };

  // 🔹 useEffect: update date label & enforce max 3 months range
  useEffect(() => {
    if (startDate && endDate) {
      const maxEndDate = moment(startDate).add(3, "months");
      if (moment(endDate).diff(moment(startDate), "months", true) > 3) {
        setEndDate(maxEndDate);
      }
      setDateLabel(getDateLabel());
    }
  }, [startDate, endDate]);

  // 🔹 useEffect: update member options from orgMembersShortList
  useEffect(() => {
    if (orgMembersShortList?.length > 0) {
      if (selectedMember) {
        const member = orgMembersShortList.find(
          m =>
            m.user_id === selectedMember?.user_id ||
            m.id === selectedMember?.id,
        );
        if (!member) {
          setSelectedMember(null);
        }
      }
      setMemberOptions(orgMembersShortList);
    } else {
      setMemberOptions([]);
    }
  }, [orgMembersShortList]);

  // 🔹 useEffect: fetch initial data whenever organization changes
  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      setSelectedMember(null);
      setCurrentPageNumber(1);
      getOfficesShortList({ organization_id: selectedOrganization.id });
      getOrganizationMembersShortList({
        organization_id: selectedOrganization.id,
      });
      getAllMemberLastClockInOut({
        organization_id: selectedOrganization.id,
      });
    }
  }, [selectedOrganization]);

  // 🔹 useEffect: update office options when officesShortList changes
  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      setSelectedOffice({ value: null, label: "(All Teams)" });
      const newArr = officesShortList.map(office => ({
        label: office.name,
        value: office.id,
      }));
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  // 🔹 useEffect: normalize raw clockInOutList into attendanceList (pairs of clock_in & clock_out)
  useEffect(() => {
    if (clockInOutList && clockInOutList.length > 0) {
      const newAttendances = [];
      clockInOutList.forEach(element => {
        if (element.attendances && element.attendances.length > 1) {
          let newList = element.attendances.sort(
            (a, b) => a.timestamp - b.timestamp,
          );
          let i = 0;
          while (i < newList.length) {
            const data = { employee: element.employee, attendance: {} };
            let iteratorValue = 1;
            if (newList[i].type === "clock_in") {
              data.attendance.clockIn = newList[i];
              if (newList[i + 1] && newList[i + 1].type === "clock_out") {
                data.attendance.clockOut = newList[i + 1];
                iteratorValue = 2;
              }
            } else if (newList[i].type === "clock_out") {
              data.attendance.clockOut = newList[i];
              data.attendance.clockIn = null;
            }
            newAttendances.push(data);
            i = i + iteratorValue;
          }
        } else if (element.attendances && element.attendances.length === 1) {
          const data = { employee: element.employee, attendance: {} };
          if (element.attendances[0].type === "clock_in") {
            data.attendance.clockIn = element.attendances[0];
            data.attendance.clockOut = null;
          } else if (element.attendances[0].type === "clock_out") {
            data.attendance.clockIn = null;
            data.attendance.clockOut = element.attendances[0];
          }
          newAttendances.push(data);
        }
      });
      setAttendanceList(newAttendances);
    }
  }, [clockInOutList]);

  // handles pagination page change
  const handlePageChange = page => {
    setCurrentPageNumber(page);
  };

  // prepares payload and fetches data from API
  const getData = () => {
    if (selectedOrganization && selectedOrganization.id) {
      const payload = {
        organization_id: selectedOrganization.id,
        start_timestamp: moment(startDate).startOf("day").unix(),
        end_timestamp: moment(endDate).endOf("day").unix(),
        tz: selectedOrganization.timezone,
        attendanceFilter: attendanceFilter?.value,
        officeFilter: selectedOffice?.value,
      };

      if (selectedMember?.user_id || selectedMember?.id) {
        payload.employee_id = selectedMember.user_id ?? selectedMember.id;
      }

      if (currentPageNumber) {
        payload.page = currentPageNumber;
      }

      if (selectedOffice?.value) {
        payload.officeFilter = selectedOffice.value;
      }

      getClockInOutList(payload);
    }
  };

  // sets selected office filter and fetches office details + members
  const selectOffice = e => {
    setSelectedOffice(e);
    setSelectedMember(null); // reset selected member

    if (e?.value && selectedOrganization?.id) {
      const payload = {
        organization_id: selectedOrganization.id,
        office_id: e.value,
      };
      getOfficeDetails(payload); // dispatch redux action
    } else {
      // Reset back to all members if no office selected
      if (selectedOrganization?.id) {
        getOrganizationMembersShortList({
          organization_id: selectedOrganization.id,
        });
      }
    }
  };

  const onlineMap = Object.fromEntries(
    onlineMembers.map(m => [m.id, m.clockin_timestamp]),
  );
  // 🔹 useEffect: refetch data whenever filters, date, page, or org changes
  useEffect(() => {
    getData();
  }, [
    dateChanged,
    currentPageNumber,
    currentSearchedTerm,
    selectedMember,
    selectedOrganization,
    attendanceFilter,
    selectedOffice,
  ]);

  // When officeDetails updates from redux, update memberOptions
  useEffect(() => {
    if (officeDetails?.employees?.length) {
      const members = officeDetails.employees.map(emp => ({
        id: emp.user.id,
        user_id: emp.user.id,
        name: `${emp.user.first_name} ${emp.user.last_name}`,
        email: emp.user.email,
        avatar: emp.user.avatar,
      }));
      setMemberOptions(members);
    } else {
      setMemberOptions([]);
    }
  }, [officeDetails]);

  // 🔹 useEffect: refetch member list when office filter changes
  // useEffect(() => {
  //   if (selectedOrganization && selectedOrganization.id) {
  //     setSelectedMember(null); // clear when office changes
  //     const payload = { organization_id: selectedOrganization.id };
  //     if (selectedOffice?.value) {
  //       if (selectedOffice?.value === "office_users") {
  //         payload.officeFilter = "office_users";
  //       } else if (selectedOffice?.value === "remote_users") {
  //         payload.officeFilter = "remote_users";
  //       } else {
  //         payload.office_id = selectedOffice.value;
  //       }
  //     }
  //     getOrganizationMembersShortList(payload);
  //   }
  // }, [selectedOffice]);

  // 🔹 useEffect: enforce max 3 months date range
  useEffect(() => {
    if (startDate && !endDate) {
      setEndDate(startDate);
    }
    if (startDate && endDate) {
      const maxEndDate = moment(startDate).add(3, "months");
      if (moment(endDate).diff(moment(startDate), "months", true) > 3) {
        setEndDate(maxEndDate);
      }
    }
  }, [startDate, endDate]);

  // handles exporting clock in/out data
  const handleExportClockInOutList = () => {
    const name = currentSearchedTerm.toLocaleLowerCase().trim();
    if (selectedOrganization && selectedOrganization.id) {
      const payload = {
        organization_id: selectedOrganization.id,
        start_timestamp: moment(startDate).startOf("day").unix(),
        end_timestamp: moment(endDate).endOf("day").unix(),
        time_format: timeFormat,
        tz: selectedOrganization.timezone,
        attendanceFilter: attendanceFilter?.value,
        officeFilter: selectedOffice?.value,
      };
      if (selectedMember?.user_id || selectedMember?.id) {
        payload.employee_id = selectedMember.user_id ?? selectedMember.id;
      }
      exportClockInOutList(payload);
    }
    toggle();
  };

  return (
    <div className="content">
      {/* Export Modal */}
      <BackendExportModal
        isOpen={isExportModalOpen}
        toggle={toggle}
        excelExport={handleExportClockInOutList}
        title="Clock In/Out"
        timeFormat={timeFormat}
        setTimeFormat={setTimeFormat}
      />
      <ContainerNew>
        {/* Page Title */}
        <PageTitle>{t("attendance")}</PageTitle>
        {/* Filters */}
        <StickyFilterContainer
          showShadow={showShadow}
          margin="0"
          paddingLeft="0"
          paddingRight="0"
        >
          <HeaderContainer margin="0px">
            <CommonFlexWrap alignItems="end" flex-flow="row wrap">
              {!isOperationType ? (
                <InputWithLabelSection>
                  <FilterLabel>Attendance</FilterLabel>
                  <Select
                    isSearchable={false}
                    isClearable={!!attendanceFilter?.value}
                    value={attendanceFilter}
                    options={attendanceFilterOptions}
                    placeholder=""
                    onChange={opt =>
                      updateAttendanceFilter(
                        opt ?? { value: null, label: "(All Attendance)" },
                      )
                    }
                    styles={CreateProjectDropdown(null)}
                    components={{
                      IndicatorSeparator: () => null,
                      ClearIndicator: props => <ClearFilterButton {...props} />,
                    }}
                  />
                </InputWithLabelSection>
              ) : (
                <CommonFilterNew
                  labelName="attendance_team"
                  count={CommonFilterSelectedCount}
                  clearAll={() => {
                    setAttendanceFilter({
                      value: null,
                      label: "(All Attendance)",
                    });
                    setSelectedOffice({ value: null, label: "(All Teams)" });
                  }}
                >
                  {/* Attendance Filter */}
                  <InputWithLabelSection>
                    <FilterLabel>Attendance</FilterLabel>
                    <Select
                      isSearchable={false}
                      isClearable={!!attendanceFilter?.value}
                      value={attendanceFilter}
                      options={attendanceFilterOptions}
                      placeholder=""
                      onChange={opt =>
                        updateAttendanceFilter(
                          opt ?? { value: null, label: "(All Attendance)" },
                        )
                      }
                      styles={CreateProjectDropdown(null)}
                      components={{
                        IndicatorSeparator: () => null,
                        ClearIndicator: props => (
                          <ClearFilterButton {...props} />
                        ),
                      }}
                    />
                  </InputWithLabelSection>
                  {/* Office Filter */}
                  <InputWithLabelSection>
                    <FilterLabel>Team</FilterLabel>
                    <Select
                      isSearchable={false}
                      isClearable={selectedOffice?.value !== null}
                      value={selectedOffice}
                      options={officeFilterOptions}
                      placeholder=""
                      onChange={opt =>
                        selectOffice(
                          opt ?? { value: null, label: "(All Teams)" },
                        )
                      }
                      styles={CreateProjectDropdown(null)}
                      components={{
                        IndicatorSeparator: () => null,
                        ClearIndicator: props => (
                          <ClearFilterButton {...props} />
                        ),
                      }}
                    />
                  </InputWithLabelSection>
                </CommonFilterNew>
              )}
              {/* Member Filter */}
              <InputWithLabelSection>
                <FilterLabel>Member</FilterLabel>
                <AddSingleMemberDropdown
                  assigneeManage={selectedMember}
                  updateState={onMemberSelect}
                  membersList={memberOptions}
                  clearAssignee={() => clearSelectedMember()}
                  loading={memberShortListIsLoading}
                  closeDisabled={true}
                  page={"attendance"}
                />
              </InputWithLabelSection>{" "}
              {/* Date Range Picker */}
              <CommonFlexWrap gap="4px" alignItems="end">
                <InputWithLabelSection>
                  <CommonFlex gap="6px" alignItems="center" disableResponsive>
                    <FilterLabel>
                      {t("date_range")}
                      {` (${dateLabel})`}
                    </FilterLabel>
                    <HelperIcon text={t("choose_the_range_of_dates_you_want_the_attendance_data_for")} />
                  </CommonFlex>
                  <ReactDateRangePicker
                    startDate={startDate ? moment(startDate) : null}
                    startDateId="report-date-range-start-date"
                    endDate={endDate ? moment(endDate) : null}
                    endDateId="report-date-range-end-date"
                    onDatesChange={changeDateRange}
                    onDateSelect={() => {
                      setDateChanged(!dateChanged);
                    }}
                    selectLastWeek={selectLastWeek}
                    selectLastMonth={selectLastMonth}
                    selectNextWeek={selectNextWeek}
                    rangeRestricted={true}
                    disableFutureDates={false}
                  />
                </InputWithLabelSection>
                {/* Date navigation arrows */}
                <IconArrow
                  onClick={() => singleDateChange("left")}
                  padding="5px"
                  size="39px"
                  src={LeftArrow_3}
                />
                <IconArrow
                  onClick={() => {
                    moment(endDate).isBefore(moment().subtract(1, "day")) &&
                      singleDateChange("right");
                  }}
                  disabled={
                    !moment(endDate).isBefore(moment().subtract(1, "day"))
                  }
                  padding="5px"
                  size="39px"
                  src={RightArrow_3}
                />
                {/* Today Button */}
                <WhiteButton
                  type="nav"
                  style={{ height: "38px", padding: "0px 15px" }}
                  onClick={selectToday}
                  borderRadius="6px"
                >
                  Today
                </WhiteButton>

              </CommonFlexWrap  >
            </CommonFlexWrap>

            {/* Export Button */}
            <CommonFlex alignItems="end">
              {(selectedOrganization?.role === "admin" ||
                selectedOrganization?.role === "owner" ||
                selectedOrganization?.role === "team_leader") &&
                clockInOutList?.length >= 0 && (
                  <ExportButtonWithIcon onClick={() => toggle()}>
                    <ExportButtonIcon src={ExportIcon} alt="" size="15px" />
                    Export
                  </ExportButtonWithIcon>
                )}
            </CommonFlex>
          </HeaderContainer>
        </StickyFilterContainer>
        {/* Pagination (Top) */}
        {clockInOutListCount &&
        clockInOutListCount > 0 &&
        clockInOutPageSize ? (
          <TopPagination
            itemName="members"
            totalCount={clockInOutListCount}
            currentPage={currentPageNumber}
            onPageChange={page => handlePageChange(page)}
            pageSize={clockInOutPageSize}
          />
        ) : null}
        {/* Table */}
        <ClockInOutTable
          clockInOutList={clockInOutList?.map(data => ({
            ...data,
            isOnline: !!onlineMap[data.employee.id],
            backup_clockin_timestamp: onlineMap[data.employee.id] || null,
          }))}
          selectedOrganization={selectedOrganization}
          selectedMember={selectedMember}
          selectedOffice={selectedOffice}
          isLoading={isLoading}
          history={history}
          startDate={startDate}
          endDate={endDate}
          isOperationType={isOperationType}
        />
        {/* Pagination (Bottom) */}
        {clockInOutListCount &&
        clockInOutListCount > 0 &&
        clockInOutPageSize ? (
          <BottomPagination
            totalCount={clockInOutListCount}
            currentPage={currentPageNumber}
            onPageChange={page => handlePageChange(page)}
            pageSize={clockInOutPageSize}
          />
        ) : null}
      </ContainerNew>
    </div>
  );
};

export default ClockInOut;
